export default {"src":"/_next/static/media/helio-dark-h.a330559e.svg","height":34,"width":146,"blurWidth":0,"blurHeight":0};